module.exports = __webpack_public_path__ + "static/media/03.8bc1922.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/03.mp4
// module id = /wri
// module chunks = 1